import React from "react";

const ClientCrudTableSearch = ({
        setFind,
        validateInputOfSearch, 
        listClientsByNumDocument,
        listClientsByMail,
        listClientsByName,
        formRef,
    }) => {

    const handleChange = (e) => {
        setFind({[e.target.name]: e.target.value});
    }
    
    const handleSubmit = (e) => {       //click en buscar
        var optionSelected = parseInt(document.querySelector('#busqueda').value);
        console.log("optionSelected : "+ optionSelected);
        e.preventDefault();
        if (optionSelected === 1) {
            listClientsByNumDocument();
        }else if (optionSelected === 2) {
            listClientsByMail();
        }else if (optionSelected === 3) {
            listClientsByName();
        }else if (optionSelected === 0) {
            validateInputOfSearch();
        }       
    }

    return (
        <div>    
            <div className="row mb-2">
                <h6>Busqueda de Clientes</h6>
            </div>
            <div className="table-responsive rounded-3 d-flex justify-content-center" style={{border:'1px solid black', paddingTop:'15px'}}>
                <>
                    <form className="row g-3" ref={formRef}>
                        <div className="col-auto">
                            <select id="busqueda" className="form-select" aria-label="Default select example">
                                <option value="0">Seleccione</option>
                                <option value="1">Número de Documento</option>
                                <option value="2">Correo</option>
                                <option value="3">Nombre</option>
                            </select>
                        </div>
                        <div className="col-auto">
                            <input type="text" className="form-control" id="find" name="find" onChange={handleChange}/>
                        </div>
                        <div className="col-auto">
                            <button type="submit" className="btn btn-primary mb-3" onClick={handleSubmit}>Buscar</button>
                        </div>
                    </form> 
                </>
            </div>
        </div>
    );
}
export default ClientCrudTableSearch;